var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn-principal",style:({ background: _vm.btnUi.background, color: _vm.btnUi.color }),on:{"click":function($event){return _vm.funcionBtn()}}},[_vm._v(" "+_vm._s(_vm.btnUi.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }